/**
 * @generated SignedSource<<9efb691375b9c2ba4112dd6d5720aaa1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventAttendeeStatus = "ATTENDING_IN_PERSON" | "ATTENDING_VIRTUAL" | "NOT_ATTENDING" | "PENDING_APPROVAL" | "WAITING_IN_PERSON" | "WAITING_VIRTUAL" | "%future added value";
export type EventAttendeeTicketPurchaseStatuses = "CANCELED" | "PENDING" | "SUCCEEDED" | "%future added value";
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventScreenAttendCard_event$data = {
  readonly attendingCount: {
    readonly totalCount: number;
  };
  readonly endAt: string;
  readonly eventAttendeesByRelevance: {
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EventAttendeesOverlap_eventAttendees">;
  };
  readonly eventTicketingTiers: {
    readonly totalCount: number;
  };
  readonly myAttendance: {
    readonly status: EventAttendeeStatus;
    readonly ticketPurchase: {
      readonly status: EventAttendeeTicketPurchaseStatuses | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly owner: {
    readonly __typename: "Guild";
    readonly myMembership: {
      readonly membershipLevel: GuildMembershipLevel;
    } | null | undefined;
  } | {
    readonly __typename: "User";
    readonly isMe: boolean | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly slug: string;
  readonly startAt: string;
  readonly waitingCount: {
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonNew_event">;
  readonly " $fragmentType": "EventScreenAttendCard_event";
};
export type EventScreenAttendCard_event$key = {
  readonly " $data"?: EventScreenAttendCard_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenAttendCard_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenAttendCard_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "status": {
              "in": [
                "ATTENDING_IN_PERSON",
                "ATTENDING_VIRTUAL",
                "WAITING_IN_PERSON",
                "WAITING_VIRTUAL"
              ]
            }
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 8
        }
      ],
      "concreteType": "EventAttendeesConnection",
      "kind": "LinkedField",
      "name": "eventAttendeesByRelevance",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventAttendeesOverlap_eventAttendees"
        }
      ],
      "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
    },
    {
      "alias": "attendingCount",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "status": {
              "in": [
                "ATTENDING_IN_PERSON",
                "ATTENDING_VIRTUAL"
              ]
            }
          }
        }
      ],
      "concreteType": "EventAttendeesConnection",
      "kind": "LinkedField",
      "name": "eventAttendees",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
    },
    {
      "alias": "waitingCount",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "status": {
              "in": [
                "WAITING_IN_PERSON",
                "WAITING_VIRTUAL"
              ]
            }
          }
        }
      ],
      "concreteType": "EventAttendeesConnection",
      "kind": "LinkedField",
      "name": "eventAttendees",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMe",
              "storageKey": null
            }
          ],
          "type": "User",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildMembership",
              "kind": "LinkedField",
              "name": "myMembership",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "membershipLevel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Guild",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "myAttendance",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EventAttendeeTicketPurchase",
          "kind": "LinkedField",
          "name": "ticketPurchase",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventTicketingTiersConnection",
      "kind": "LinkedField",
      "name": "eventTicketingTiers",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventAttendButtonNew_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "13b5d151a89d68c49bf9dcdc7e4b91b3";

export default node;
